<script setup lang="tsx">
import type { Ref } from 'vue'

const emit = defineEmits(['delete', 'edit'])
const props = defineProps<{
	canEdit?: Ref<boolean>
	canDelete?: Ref<boolean>
	editId?: string
	deleteId?: string
}>()
</script>

<template>
	<div class="d-flex gap-2">
		<button
			v-if="props.deleteId && props.canDelete?.value"
			:data-test="props.deleteId"
			class="btn btn-outline-danger flex-fill"
			@click="emit('delete')"
		>
			{{ $t('misc.delete') }}
		</button>
		<button v-if="props.canEdit?.value" :data-test="props.editId" class="btn btn-primary flex-fill" @click="emit('edit')">
			{{ $t('misc.edit') }}
		</button>
	</div>
</template>

<style lang="sass" scoped></style>
